export interface NameValue {
	name: string;
	value: number;
	colorValue?: string | number;
}

/**
 * Reducer to sum up all values from an array of NameValue objects
 * @param runningTotal
 * @param nameValue
 */
export const sumValuesReducer = (runningTotal: number, nameValue: NameValue) => runningTotal + nameValue.value;
